import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import PlusIcon from 'components/atoms/icons/plus';
import Input from 'components/atoms/input';
import forms from 'constants/forms';
import RemoveIcon from '../../../../atoms/icons/remove';

const RunBook = ({ errors, values, setFieldValue }) => {
  const runBookFields = [...forms.adminPanelsClinic.clinicEdit.runBook];
  const [showRunBookForm, setShowRunBookForm] = useState(!!values?.notes);

  const handleClose = () => {
    setShowRunBookForm(false);
    setFieldValue('validateRunBook', false);
    setFieldValue('notes', '');
    setFieldValue('dateNoteLogged', '');
  };

  const handleOpen = () => {
    setShowRunBookForm(true);
    setFieldValue('validateRunBook', true);
  };

  return (
    <div className="admin-patient-form-block">
      <div className="admin-patient-header-space-between">
        <span>Clinic Instructions</span>
        {!showRunBookForm && (
          <span className="admin-patient-form__add-button" onClick={handleOpen}>
            <PlusIcon />
          </span>
        )}
      </div>
      {showRunBookForm && (
        <Row className="admin-patient-relative">
          <span
            className="admin-patient-form-block__remove-icon"
            onClick={() => {
              handleClose();
            }}
          >
            <RemoveIcon />
          </span>
          {runBookFields.map((field) => (
            <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
              <>
                <Input {...field} disabled={false} />
                {errors[field.id] ? (
                  <div className="input-error">
                    {errors[field.id].split('.')[0]}
                  </div>
                ) : null}
              </>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

RunBook.propTypes = {
  errors: PropTypes.shape({}).isRequired,
  values: PropTypes.shape(),
  setFieldValue: PropTypes.func,
};

export default RunBook;
